import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { previousOrderModalStore } from '../../store/previousOrderModalStore';
import { localeStore } from '~/mobx/localesStore';
import { formatPriceSettings } from '~/utils/formatter';
import './style.scss';

export const PreviousOrderModalProductTotal: FC = memo(
  observer((): ReactElement => {
    const { loading, order, currencySettings } = previousOrderModalStore;

    return (
      <div className="previous-order-modal-product-total">
        <p className="previous-order-modal-product-total__title">{localeStore.t('txt_total')}</p>
        {loading ? (
          <Skeleton width={60} height={16.8} />
        ) : (
          <p className="previous-order-modal-product-total__price">{formatPriceSettings(order?.total || 0, currencySettings)}</p>
        )}
      </div>
    );
  })
);
